import React from "react";
import classes from "./BurgerIngredient.module.css";

function BreadTop() {
  return (
    <div className={classes.BreadTop}>
      <div className={classes.Seeds1}></div>
      <div className={classes.Seeds2}></div>
    </div>
  );
}

export default BreadTop;
